/**
 * Het laatst bekende profiel van het actieve bedrijf (licentie en bètafuncties), per bedrijf in
 * localStorage. Daarmee staan menu-items en tabbladen die ervan afhangen (Labopdrachten,
 * Vooronderzoek, Rapportage) er meteen bij het laden, in plaats van pas nadat het profiel
 * binnen is. Dat laatste liet het menu bij elke paginawissel in- en uitklappen.
 *
 * Alleen weergave: de backend beslist zelf (requireGeoDesk, requireBetaFeature). Na het ophalen
 * van het echte profiel wordt deze opslag bijgewerkt.
 */
import { auth } from '../auth.js';

const sleutel = () => {
  const id = auth.getActiveCompany()?.id;
  return id ? `mv_profiel_${id}` : null;
};

/** { license, betaFeatures } of null als er nog niets bekend is. */
export function profielUitOpslag() {
  const k = sleutel();
  if (!k) return null;
  try {
    const v = JSON.parse(localStorage.getItem(k) || 'null');
    if (v && typeof v === 'object') return { license: v.license ?? null, betaFeatures: Array.isArray(v.betaFeatures) ? v.betaFeatures : [] };
  } catch (_) { /* kapot of privémodus */ }
  // Oudere opslag kende alleen de licentie.
  try {
    const license = localStorage.getItem(`mv_license_${auth.getActiveCompany()?.id}`);
    return license ? { license, betaFeatures: null } : null;
  } catch (_) { return null; }
}

export function profielOnthouden(profile) {
  const k = sleutel();
  if (!k || !profile) return;
  try {
    localStorage.setItem(k, JSON.stringify({ license: profile.license ?? null, betaFeatures: profile.betaFeatures || [] }));
  } catch (_) { /* privémodus */ }
}
